import React, { useCallback } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'

function ReviewButton() {
  const handleReviewClick = useCallback(() => {
    window.dispatchEvent(new CustomEvent('open-review-modal'))
  }, [])

  return (
    <Button
      type="primary-warning"
      customClass="pricing-area__actions-button pricing-area__actions-right-button"
      size="large"
      onClick={handleReviewClick}
      aria-label="Review"
    >
      Review
    </Button>
  )
}

export default ReviewButton
